import React, { useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import PopularDestinations from './PopularDestinations'
import RecentLocationsSearch from './RecentLocationsSearch'

interface Props {
  setValue: (value: App.SearchItem) => void;
  recentSearchItems?: Array<App.SearchItem>;
  popularPlaces?: Array<App.SearchItem>;
  resultCount: number;
  message?: string;
}

const ErrorMessageContainer = styled.div`
  > * + * {
    margin-top: ${rem(4)};
  }
`

const OptionsContainer = styled.div`
  color: ${({ theme }) => theme.palette.neutral.one};
`

function LocationSearchFieldNoOptionsMessage({
  resultCount,
  recentSearchItems,
  popularPlaces,
  setValue,
  message,
}: Props) {
  const { location } = useContext(GlobalSearchStateContext)
  if (location.length > 1 && resultCount === 0) {
    return (<ErrorMessageContainer>
      <BodyText variant="medium" colour="neutral-two">
        Sorry, we couldn't find <b>&lsquo;{location}&rsquo;</b>.
      </BodyText>

      {message && <BodyText variant="small" colour="neutral-two">{message}</BodyText>}
    </ErrorMessageContainer>)
  }

  const hasRecentOptions = recentSearchItems?.length > 0

  return (
    <OptionsContainer>
      {hasRecentOptions && <RecentLocationsSearch
        setValue={setValue}
        recentSearchItems={recentSearchItems}
      />}

      {!hasRecentOptions && <PopularDestinations
        recentSearchItems={recentSearchItems}
        onSearchDestinationSelect={setValue}
        popularPlaces={popularPlaces}
      />}
    </OptionsContainer>
  )
}

export default LocationSearchFieldNoOptionsMessage
